// src/components/Teabates/IssueTeabateAvatar.tsx
import React from 'react';
import { Issue } from 'util/constants';

interface IssueTeabateAvatarProps {
  issue: Issue;
  hasTeabates: boolean;
  onClick: () => void;
  className?: string;
  showTitle?: boolean;
}

const IssueTeabateAvatar: React.FC<IssueTeabateAvatarProps> = ({
  issue,
  hasTeabates,
  onClick,
  className = '',
  showTitle = false
}) => {
  const IMAGE_CDN = process.env.REACT_APP_IMAGE_CDN;
  
  const getIssueImageUrl = () => {
    if (issue.properties?.subject_properties?.reference_link_img_key) {
      return `${IMAGE_CDN}/${issue.properties.subject_properties.reference_link_img_key}`;
    }
    if (issue.properties?.subject_properties?.thumbnail?.source) {
      return issue.properties.subject_properties.thumbnail.source;
    }
    if (issue.properties?.subject_properties?.wiki_parse_first_img) {
      return issue.properties.subject_properties.wiki_parse_first_img;
    }
    return null;
  };
  
  const imageUrl = getIssueImageUrl();
  
  return (
    <button
      onClick={onClick}
      className={`relative flex flex-col items-center ${className}`}
    >
      <div className={`w-16 h-16 rounded-full overflow-hidden p-0.5 relative
        ${hasTeabates 
          ? 'border-2 border-eoe-primary dark:border-eoe-dark-primary gradient-border' 
          : 'border-2 border-gray-300 dark:border-gray-700'}`}
      >
        {imageUrl ? (
          <img 
            src={imageUrl}
            alt={issue.name}
            className="w-full h-full object-cover rounded-full"
          />
        ) : (
          <div className="w-full h-full bg-gray-200 dark:bg-gray-700 rounded-full flex items-center justify-center text-gray-500 dark:text-gray-400">
            {issue.name.substring(0, 1).toUpperCase()}
          </div>
        )}
      </div>
      {showTitle && (
        <span className="text-xs mt-1 max-w-[70px] truncate font-medium">
          {issue.name}
        </span>
      )}
      <style dangerouslySetInnerHTML={{
        __html: `
          .gradient-border {
            position: relative;
          }
          .gradient-border::before {
            content: '';
            position: absolute;
            top: -3px;
            left: -3px;
            right: -3px;
            bottom: -3px;
            background: linear-gradient(45deg, #f09433, #e6683c, #dc2743, #cc2366, #bc1888);
            border-radius: 50%;
            z-index: -1;
          }
        `
      }} />
    </button>
  );
};

export default IssueTeabateAvatar;
